<template>
  <div id="smartpost-user" class="section-for-user-smartpost">
    <div class="for-user-card">
      <div class="heading-group">
        <div class="subtitle title-letter-spacing">
          {{ getWordings.smartpostSectionUserSubtitle }}
        </div>
        <div class="title">
          {{ getWordings.smartpostSectionUserTitle }}
        </div>
      </div>
      <div class="left-side">
        <img
          class="for-user-img"
          :src="require('@/assets/images/smartpost_section_smartpost.png')"
        />
      </div>
      <div class="right-side">
        <div class="headline" v-html="getWordings.smartpostSectionUserPlainTitle"></div>
        <div class="description" v-html="getWordings.smartpostSectionUserPlainDescription"></div>
        <LinkButton
          class="link-button"
          :wordingKey="'smartpostSectionUserButton'"
          :hrefLink="smartpostLpURL"
          :isShowIcon="false"
          :openNewTab="true"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import LinkButton from "@/components/controls/LinkButton.vue";

@Component({
  components: {
    LinkButton
  },
  inject: ["routes"]
})
export default class SectionForUserSmartPOST extends Vue {
  @Getter("text/getWordings") getWordings!: any;
  smartpostLpURL = process.env.VUE_APP_SMARTPOST_LP_URL as string;
}
</script>

<style lang="scss" scoped>
.section-for-user-smartpost {
  @include size(100%, auto);
  @include layoutPadding();
  background: $white;
  padding-top: 100px;
  padding-bottom: 100px;

  .for-user-card {
    display: grid;
    grid-template-columns: 40% 1fr;
    grid-template-areas:
      "heading  heading"
      "image    content";
    column-gap: 100px;
    width: 100%;
    background: $white;
    box-sizing: border-box;

    @include mq(l) {
      grid-template-columns: 100%;
      grid-template-areas:
        "heading"
        "image"
        "content";
      column-gap: 0;
    }
  }

  .heading-group {
    grid-area: heading;
    justify-self: center;
    text-align: center;
    margin-bottom: 60px;
    @include mq(l) {
      margin-bottom: 24px;
    }
  }

  .subtitle {
    @include fz(s);
    @include fw(bold);
    color: $gs5;
    text-align: center;
  }

  .title {
    @include titleFz(m);
    @include fw(heavy);
    color: $black;
    line-height: 44px;
    text-align: center;
    @include mq(l) {
      @include fz(l);
      line-height: normal;
    }
  }

  .left-side {
    grid-area: image;
    @extend %centerContent;
    @include mq(l) {
      margin-bottom: 24px;
    }

    .for-user-img {
      width: 100%;
      max-width: 100%;
      height: auto;
      @include mq(l) {
        width: 70%;
      }
    }
  }

  .right-side {
    grid-area: content;
    text-align: left;
    @include mq(l) {
      text-align: center;
    }

    .headline {
      @include titleFz(s);
      @include fw(bold);
      color: $black;
      margin-bottom: 15px;
      text-align: left;
      @include mq(l) {
        @include fz(l);
      }
    }

    .description {
      @include fz(xxl);
      @include fw(normal);
      color: $gs4;
      line-height: 1.8;
      margin-bottom: 60px;
      @include mq(l) {
        @include fz(m);
        text-align: left;
      }
    }

    .link-button {
      display: inline-block;
      @include mq(l) {
        display: block;
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
      }
    }

    ::v-deep .link-button {
      @include mq(l) {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }

  @include mq(l) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
</style>
